<template>
  <div class="pa-10">
    <StudentToOrgMatchingDataTable />
  </div>
</template>

<script>
import StudentToOrgMatchingDataTable from "@/components/Utils/StudentToOrgMatchingDataTable.vue";
export default {
  components: {
    StudentToOrgMatchingDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
